module.exports = __webpack_public_path__ + "static/media/raise.70334e05.svg";